module.exports = __webpack_public_path__ + "assets/logo1.3c5d478d.svg";